export default {
  /*
    船舶一覧画面
  */
  SET_VESSELS(state, data) {
    state.vessels = data;
  },
  SET_VESSEL_TOTAL_PAGE(state, data) {
    state.vesselTotalPage = data;
  },
  SET_VESSEL_TOTAL_ELEMENTS(state, data) {
    state.vesselTotalElements = data;
  },

  /*
    航海一覧画面
  */
  SET_VOYAGES(state, data) {
    state.voyages = data;
  },
  SET_VOYAGE_TOTAL_PAGE(state, data) {
    state.voyageTotalPage = data;
  },
  SET_VOYAGE_TOTAL_ELEMENTS(state, data) {
    state.voyageTotalElements = data;
  },

  /*
    省エネ解析画面
  */
  // マップ関係
  SET_START_PORT(state, data) {
    state.startPort = data;
  },

  SET_GOAL_PORT(state, data) {
    state.goalPort = data;
  },

  //航路情報
  SET_USUAL_ROUTE(state, data) {
    state.usualRoute = data;
  },

  SET_RECOMENDED_ROUTE(state, data) {
    state.recomendedRoute = data;
  },

  SET_ACTUAL_ROUTE(state, data) {
    state.actualRoute = data;
  },

  SET_USUAL_ROUTE_WAYPOINTS(state, data) {
    state.usualRouteWaypoints = data;
  },

  SET_RECOMENDED_ROUTE_WAYPOINTS(state, data) {
    state.recomendedRouteWaypoints = data;
  },

  SET_ACTUAL_ROUTE_WAYPOINTS(state, data) {
    state.actualRouteWaypoints = data;
  },

  SET_ROUTE_AGREEMENT_RATE(state, data) {
    state.routeAgreementRate = data;
  },

  SET_MAP_CENTER_POSITION(state, data) {
    state.mapCenterPosition = data;
  },

  SET_OPERATION_RATE(state, data) {
    state.operationRate = data;
  },

  RESET_CHART_SERIES(state, data) {
    state.chartSeries = data;
  },

  // グラフ関係
  SET_CHART_SERIES(state, data) {
    state.chartSeries = data;
  },

  SET_CHART_SERIES_SHOW_SWITCH(state, data) {
    state.chartSeries = state.chartSeries.map(item => {
      item.showSwitch = data.includes(item.key);
      item.enabled = data.includes(item.key);
      return item;
    });
  },

  SET_ACTUAL_ROUTE_EXISTS_RECOMMENDED_AGGREGATED_DATA(state, data) {
    state.actualRouteExistsRecommendedAggregatedData = data;
  },

  SET_CHART_DATA(state, data) {
    state.chartData = data;
  },

  SET_ENABLED_SWITCH_MODELS(state, data) {
    state.enabledSwitchModels = data;
  },

  SET_SENSOR_COLUMN(state, data) {
    state.sensorColumn = data;
  },

  SET_SENSOR_ROW_DATA(state, data) {
    state.sensorRowsData = data;
  },

  //詳細画面で使うすべての情報をリセット
  RESET_DETAIL_DATA(state) {
    const detailState = {
      //省エネ解析詳細
      startPort: {},
      goalPort: {},

      //航路情報
      usualRoute: {},
      usualRouteWaypoints: [],
      recomendedRoute: {},
      recomendedRouteWaypoints: [],
      actualRoute: {},
      actualRouteWaypoints: [],
      routeAgreementRate: null,

      //マップ
      showMap: false,
      mapCenterPosition: [],

      //グラフ
      chartSeries: [],
      chartData: [],

      //バルコムセンサー
      sensorColumn: [],
      sensorRowsData: [],
    };

    Object.keys(detailState).forEach(key => {
      state[key] = detailState[key];
    });
  },

  SET_ACTUAL_ROUTE_LINES_FEATURES(state, data) {
    state.actualRouteLinesFeatures = data;
  },

  SET_SECTION_LINES_FEATURES(state, data) {
    state.sectionLinesFeatures = data;
  },

  SET_CURRENT_GRAPH_SYNC_LINE(state, data) {
    state.currentGraphSyncLine = data;
  },

  SET_ROUTE_FEATURE_COLLECTION(state, data) {
    state.routeFeatureCollection = data;
  },

  SET_MAP_INITIAL_POSITION(state, data) {
    state.mapInitialPosition = data;
  },

  SET_WEATHER_ROUTING_RESULTS_DATA(state, data) {
    state.weatherRoutingResultsData = data;
  },

  //すべてのstateをリセットする
  RESET_ALL_STATE(state) {
    const allState = {
      //船舶一覧
      vessels: [],
      vesselId: null,
      vesselTotalPage: null,
      vesselTotalElements: null,

      //航海一覧
      voyages: [],
      voyageId: null,
      voyageTotalPage: null,
      voyageTotalElements: null,

      //省エネ解析詳細
      startPort: {},
      goalPort: {},

      //航路情報
      usualRoute: {},
      usualRouteWaypoints: [],
      recomendedRoute: {},
      recomendedRouteWaypoints: [],
      actualRoute: {},
      actualRouteWaypoints: [],
      actualRouteExistsRecommendedAggregatedData: {},
      routeAgreementRate: null,
      operationRate: null,
      routeFeatureCollection: null,

      //マップ
      showMap: false,
      mapCenterPosition: null,
      actualRouteLinesFeatures: null,
      sectionLinesFeatures: null,
      currentGraphSyncLine: null,
      mapInitialPosition: null,

      //グラフ
      chartSeries: [],
      chartData: [],
      enabledSwitchModels: [],

      //バルコムセンサー
      sensorColumn: [],
      sensorRowsData: [],
    };

    state = allState;
  },
};
